import { isChatGroupActive } from './isChatGroupActive'

/**
 * Normalizes one chat group record from socket (list row, create, or update).
 */
export function normalizeChatGroupSocketRecord (item) {
  if (!item || item.id == null) return null
  if (!isChatGroupActive(item)) return null

  const userIds = [
    ...new Set(
      (item.userIds ?? item.users?.map(u => u.id).filter(Boolean) ?? []).map(id => String(id))
    )
  ]
  const deviceIds = [
    ...new Set(
      (item.deviceIds ?? item.devices?.map(d => d.id || d.uuid_device).filter(Boolean) ?? []).map(id =>
        String(id)
      )
    )
  ]
  const hasUserMembershipPayload =
    Array.isArray(item.userIds) ||
    Array.isArray(item.user_ids) ||
    Array.isArray(item.users)
  const hasDeviceMembershipPayload =
    Array.isArray(item.deviceIds) ||
    Array.isArray(item.device_ids) ||
    Array.isArray(item.devices)
  const memberCount = hasUserMembershipPayload
    ? userIds.length
    : (item.memberCount ?? item.member_count ?? 0)
  const attachedDeviceCount = hasDeviceMembershipPayload
    ? deviceIds.length
    : (item.attachedDeviceCount ?? item.attached_device_count ?? 0)

  return {
    id: item.id,
    name: item.name,
    description: item.description ?? null,
    photoId: item.photoId ?? item.photo_id ?? null,
    photoUrl: item.photoUrl ?? item.photo_url ?? null,
    nrOfUnreadMessages: item.nrOfUnreadMessages ?? item.nr_of_unread_messages ?? 0,
    hasDangerUnread: !!(item.hasDangerUnread ?? item.has_danger_unread),
    lastMessageAt: item.lastMessageAt ?? item.last_message_at ?? null,
    lastMessageContent: item.lastMessageContent ?? item.last_message_content ?? null,
    memberCount,
    attachedDeviceCount,
    userIds,
    deviceIds,
    users: item.users,
    devices: item.devices,
    createdByUserId: item.createdByUserId ?? item.created_by_user_id ?? null,
    isActive: item.isActive ?? item.is_active ?? true,
    isDeleted: item.isDeleted ?? item.is_deleted ?? false,
    deleted: item.deleted ?? false
  }
}

/**
 * Maps chatGroup::list / chatGroups::get socket payload into list-fetch shape for normalization.
 */
export function normalizeChatGroupListSocketResult (result) {
  const items = result?.items || result?.data?.items || []
  const normalizedItems = items.map(normalizeChatGroupSocketRecord).filter(Boolean)

  return {
    totalCount: normalizedItems.length,
    items: normalizedItems
  }
}
